module.exports = __webpack_public_path__ + "img/20191008160031360截图20191008143153564.cb71d91d.jpg";